import { useContext, useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { MenuUnfoldOutlined } from "@ant-design/icons";

import Sider from "../Sider/Sider";
import Header from "../Header/Header";
import AppContext from "../../../context/AppContext";
import { PageTitleProvider } from "./PageTitleContext";
import { AppStrings } from "../../../utils/constants/AppStrings";

function Layout() {
  const { isExpanded, setIsDropdownOpen } = useContext(AppContext);
  const { pathname } = useLocation();
  const contentContainerRef = useRef(null);
  const [isMobileSiderOpen, setIsMobileSiderOpen] = useState(false);

  useEffect(() => {
    setIsDropdownOpen(false);
    setIsMobileSiderOpen(false);

    const contentContainer = contentContainerRef.current;
    if (contentContainer) {
      contentContainer.scrollTop = 0;
      contentContainer.dispatchEvent(new Event("scroll"));
    }
  }, [pathname, setIsDropdownOpen]);

  useEffect(() => {
    if (!isMobileSiderOpen) return undefined;

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setIsMobileSiderOpen(false);
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [isMobileSiderOpen]);

  return (
    <PageTitleProvider>
      <div
        className={`pageContainer ${
          isMobileSiderOpen ? "mobile-sider-is-open" : ""
        }`}
      >
        <Header />
        {!isMobileSiderOpen && (
          <button
            type="button"
            className="mobile-sider-trigger"
            aria-label={AppStrings.PAM_OPEN_NAVIGATION_MENU}
            aria-expanded="false"
            onClick={() => setIsMobileSiderOpen(true)}
          >
            <MenuUnfoldOutlined />
          </button>
        )}
        {isMobileSiderOpen && (
          <button
            type="button"
            className="mobile-sider-backdrop"
            aria-label={AppStrings.PAM_CLOSE_NAVIGATION_MENU}
            onClick={() => setIsMobileSiderOpen(false)}
          />
        )}
        <div style={{ display: "flex" }}>
          <Sider
            isExpanded={isExpanded}
            isMobileDrawerOpen={isMobileSiderOpen}
            onMobileClose={() => setIsMobileSiderOpen(false)}
          />
          <div
            ref={contentContainerRef}
            data-testid="content-container"
            className={`contentContainer ${isExpanded ? "expanded" : "collapsed"}`}
          >
            <div className="layoutPage" data-testid="layout-page">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </PageTitleProvider>
  );
}

export default Layout;